<template>
  <main>
    <div class="certified-courses">
      <div class="section-frame" v-if="certificatedCoursesInfo">
        <ul class="breadcrumbs">
          <li>
            <router-link to="/"><i class="fa-home-line"></i></router-link>
          </li>
          <li><i class="fa-arrow-next"></i></li>
          <li>
            <router-link to="/certified-courses">{{
              $t("certificated_courses")
            }}</router-link>
          </li>
        </ul>
        <div class="page-sub-title jcc certified-sub-title">
          <h1>
            <i class="fa-title"></i><i>{{ $t("certificated_courses") }}</i>
          </h1>
        </div>
        <div class="certified-courses-title">
          <p>{{ $t("certificated_courses_description") }}</p>
        </div>
        <p class="empty" v-if="certificatedCoursesInfo.result === null">
          {{ $t("no_certificated_courses") }}
        </p>
        <div class="courses-list courses-list-ser">
          <div
            class="certified__card"
            v-for="(data, index) in certificatedCoursesInfo.result"
            :key="index"
          >
            <div
              v-if="
                (data.status && data.status.toUpperCase() === 'FINISHED') ||
                (data.status && data.status.toUpperCase() === 'NEW') ||
                (data.status && data.status.toUpperCase() === 'DOWNLOADING') ||
                (data.status && data.status.toUpperCase() === 'PROGRESS')
              "
              class="courses-item-status"
              :class="{
                'status-work':
                  data.status && data.status.toUpperCase() === 'PROGRESS',
                'status-finish':
                  data.status && data.status.toUpperCase() === 'FINISHED',
                'status-new':
                  data.status && data.status.toUpperCase() === 'NEW',
                'status-load':
                  data.status && data.status.toUpperCase() === 'DOWNLOADING',
              }"
            >
              <img
                v-if="data.status && data.status.toUpperCase() === 'PROGRESS'"
                src="../../assets/images/status/work.svg"
                alt=""
              />
              <img
                v-if="data.status && data.status.toUpperCase() === 'FINISHED'"
                src="../../assets/images/status/finish.svg"
                alt=""
              />
              <img
                v-if="data.status && data.status.toUpperCase() === 'NEW'"
                src="../../assets/images/status/new.svg"
                alt=""
              />
              <img
                v-if="
                  data.status && data.status.toUpperCase() === 'DOWNLOADING'
                "
                src="../../assets/images/status/load.svg"
                alt=""
              />
              <span
                v-if="data.status && data.status.toUpperCase() === 'PROGRESS'"
                >{{ $t("status_progress") }}</span
              >
              <span
                v-if="data.status && data.status.toUpperCase() === 'FINISHED'"
                >{{ $t("status_finished") }}</span
              >
              <span v-if="data.status && data.status.toUpperCase() === 'NEW'">{{
                $t("status_new")
              }}</span>
              <span
                v-if="
                  data.status && data.status.toUpperCase() === 'DOWNLOADING'
                "
                >{{ $t("course_downloading") }}</span
              >
            </div>
            <div class="certified__card-top">
              <div class="certified__card-image">
                <img :src="$mediaUrl(data.image_url)" alt="" />
              </div>
              <div class="certified__card-info">
                <div class="certified__card-name">{{ data.name }}</div>
                <div class="certified__card-category">{{ data.category }}</div>
                <div class="certified__card-lesson">
                  <i class="fa-square"></i> {{ data.sub_courses_count }}
                  <div style="margin-left: 5px">{{ $t("course") }}</div>
                </div>
                <div class="certified__card-lesson">
                  <i class="fa-book"></i> {{ data.lessons_count }}
                  <div style="margin-left: 5px">{{ $t("lessons") }}</div>
                </div>
              </div>
            </div>
            <div class="certified__card-list">
              <div
                class="certified__card-item"
                v-for="(sub_courses, key) in data.sub_courses"
                :key="key"
                @click="$router.push(`/course/${sub_courses.id}`)"
              >
                <p>{{ key + 1 }}. {{ sub_courses.name }}</p>
              </div>
            </div>
            <div class="certified__card-buttons">
              <button @click.prevent="$router.push(`/certified/${data.id}`)">
                {{ $t("details") }}
              </button>
            </div>
          </div>
        </div>

        <template v-if="loading">
          <a
            href="#"
            v-if="
              !(
                certificatedCoursesInfo.last_page ===
                certificatedCoursesInfo.page
              )
            "
            class="courses-all-hide"
          >
            <img src="../../assets/images/status/load.svg" alt="" />
          </a>
        </template>
        <template v-else>
          <a
            href="#"
            v-if="
              !(
                certificatedCoursesInfo.last_page ===
                certificatedCoursesInfo.page
              )
            "
            @click.prevent.stop="paginationCertificatedCourses"
            class="courses-all-hide"
          >
            <div>{{ $t("more_courses") }}</div>
            <i class="fa-arrow-line"></i>
          </a>
        </template>
      </div>
    </div>
  </main>
</template>

<script>
// import CoursesCard from "@/components/CoursesCard";

export default {
  data() {
    return {
      loading: false,
    };
  },
  async mounted() {
    await this.$store.dispatch("certificatedCourses", { page: 1 });
  },
  methods: {
    async pushCart(id) {
      if (localStorage.getItem("access")) {
        let obj = {
          certificated_courses: [id],
        };
        await this.$store.dispatch("addCart", obj);
      } else {
        await this.$store.commit("setError", "no-auth");
        await this.$router.push("/login");
      }
    },
    async paginationCertificatedCourses() {
      this.loading = true;
      await this.$store.dispatch(
        "paginationCertificatedCourses",
        this.certificatedCoursesInfo.page + 1,
      );
      this.loading = false;
    },
  },
  computed: {
    certificatedCoursesInfo() {
      return this.$store.getters.getCertificatedCourses;
    },
    lang() {
      return this.$store.getters.lang;
    },
  },
  components: {
    // CoursesCard
  },
};
</script>
